const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfetti(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 524.193,
    height: 492.645,
    viewBox: "0 0 138.693 130.346",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.244 1.538-.131 2.311 0 0",
    style: {
      fill: "#f7d665",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 109.414 8.676)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.243 1.538-.133 2.311 0 0",
    style: {
      fill: "#f7d665",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 108.847 5.645)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.841-1.691 1.81-3.307 2.813-4.906 1.696-2.713 3.532-5.511 4.803-8.507A36.74 36.74 0 0 1 4.812-7.67C3.022-4.666.68-1.619-.71 1.695c-.001-.001-.003-.003-.003-.005C-.499 1.117-.272.549 0 0",
    style: {
      fill: "#f7d665",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 105.058 .557)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.627-.55 1.129-1.252 1.517-1.976 1.154-2.147 1.106-4.93-.25-6.959-.455-.679-1.1-1.155-1.813-1.514-1.107.304-2.188.727-3.244 1.164a18.19 18.19 0 0 0-2.384 1.222C-5.04-4.802-3.067-1.944 0 0m19.289-31.293c-.06.432-.023.88.081 1.321a13.97 13.97 0 0 0 2.887-6.712c-1.543 1.571-2.689 3.364-2.968 5.391m-1.738-17.838c3.977.158 8.044 1.212 10.336 4.405 4.304-1.74 8.517-2.19 13.326-2.118 0 0 1.913.093 2.698.079 4.569.223 8.785.91 12.962 3.265 5.397 3.039 9.335 8.238 12.485 13.439-.639-1.055-6.446.965-7.13-.165-4.175-6.9-9.605-13.055-17.467-15.644-.882-.291-1.795-.472-2.705-.653-.042-.009-.077-.018-.117-.025-1.307.122-2.62.339-3.871.736-2.481.787-4.852 2.002-7.138 3.227-.517.277-1.07.574-1.641.895.865 3.405-.176 7.269-1.766 10.261-1.529 2.879-3.23 4.033-5.865 4.324-1.26.182-4.557.316-6.043.062-.59-.082-1.148-.225-1.621-.496-1.87-1.07-2.099-3.571-1.481-5.386 1.299-3.825 5.524-6.709 9.437-8.865-.937-3.234-3.328-5.938-7.31-6.985-.158-.041-.322-.06-.484-.095-1.297.222-2.545.683-3.75 1.205-2.904 1.261-5.38 3.397-7.534 5.677-4.624 4.895-7.632 11.329-9.287 17.799-1.069 4.183-1.413 9.061-.48 13.508a24.058 24.058 0 0 1 4.204-.474c1.205-.027 1.717-.07 2.581-.015 3.692-.017 7.54-.325 9.176 3.662C10.215-4.707 8.982-1.106 6.562.59c-1.33.936-2.959.806-4.5.779-2.402-.04-5.109.231-7.421-.58-2.346-.822-4.238-2.539-5.685-4.632a20.68 20.68 0 0 0-3.328 5.745c-3.656 9.594-.157 21.514 6.355 29.024-.284-.328-3.132-.036-3.564-.047-.48-.011-3.223.275-3.563-.117-8.157-9.403-11.278-25.489-2.484-35.502 1.254-1.428 2.73-2.576 4.324-3.514a21.668 21.668 0 0 1-1.036-3.917c-1.057-6.445.651-13.264 3.168-19.167C-8.635-37.292-4.613-42.872.818-46.48c5.106-3.395 10.89-2.885 16.733-2.651",
    style: {
      fill: "#f32874",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 33.97 17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-1.87-1.07-2.1-3.571-1.481-5.386 1.299-3.824 5.523-6.709 9.437-8.864 2.52-1.482 5.937-2.937 5.937-2.937 4.102-1.66 8.128-2.139 12.659-2.119.595.1 1.107.212 1.535.327l-.025-.005-.117-.025c-1.307.122-2.62.339-3.871.736-2.481.787-4.852 2.002-7.138 3.227-.517.277-1.07.574-1.642.895-3.44 1.837-7.031 5.006-7.031 5.006C6.72-7.574 5.574-5.781 5.295-3.754c-.06.432-.023.88.081 1.321C5.604-1.345 6.751-.249 7.608.439 6.312.62 3.088.748 1.621.496 1.031.415.473.271 0 0",
    style: {
      fill: "#ff5a9d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 40.223 26.476)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-.038-.006z",
    style: {
      fill: "#ff5a9d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 41.534 33.847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c2.537-5.954 6.559-11.534 11.99-15.142 2.962-1.968 6.152-2.621 9.447-2.778a49.77 49.77 0 0 1 3.811.406c-1.269.226-2.489.676-3.67 1.188-2.904 1.26-5.38 3.397-7.534 5.676C9.42-5.755 6.412.679 4.757 7.149c-1.069 4.184-1.413 9.061-.48 13.509.159.842.165.996.721 2.618 1.134 3.261 3.106 6.119 6.174 8.062 1.03.795 2.538 1.186 3.817 1.38-.585.023-1.176-.001-1.755-.01-2.402-.041-5.109.23-7.422-.581-2.345-.821-4.237-2.539-5.684-4.631-1.247-1.932-2.26-4.412-2.26-4.412a21.624 21.624 0 0 1-1.036-3.917C-4.226 12.722-2.517 5.904 0 0",
    style: {
      fill: "#ff5a9d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 31.621 29.05)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.647-.566 1.164-1.291 1.563-2.037C2.754-4.25 2.704-7.12 1.306-9.21c-.47-.702-1.134-1.192-1.869-1.562-1.141.313-2.255.75-3.344 1.2a18.64 18.64 0 0 0-2.458 1.26C-5.196-4.95-3.163-2.003 0 0m19.886-32.262a3.75 3.75 0 0 0 .084 1.363 14.403 14.403 0 0 0 2.976-6.919c-1.591 1.618-2.772 3.467-3.06 5.556m-1.792-18.39c4.1.164 8.293 1.25 10.656 4.543 4.438-1.795 8.781-2.259 13.738-2.184 0 0 1.973.095 2.783.081 4.71.23 9.056.938 13.362 3.365 5.564 3.134 9.625 8.493 12.872 13.856-.658-1.088-6.646.995-7.351-.17-4.304-7.114-9.903-13.459-18.007-16.128-.91-.3-1.851-.487-2.789-.674l-.12-.026c-1.348.127-2.702.349-3.991.76-2.558.811-5.003 2.063-7.36 3.326a91.22 91.22 0 0 0-1.692.923c.892 3.51-.181 7.493-1.82 10.579-1.577 2.968-3.33 4.158-6.046 4.457-1.3.188-4.699.327-6.231.064-.608-.084-1.183-.231-1.671-.511-1.927-1.104-2.164-3.682-1.527-5.553 1.34-3.943 5.695-6.917 9.729-9.139-.966-3.335-3.431-6.122-7.536-7.201-.163-.043-.331-.063-.499-.098-1.337.229-2.624.704-3.865 1.242-2.995 1.3-5.547 3.502-7.768 5.852-4.767 5.047-7.869 11.68-9.575 18.35-1.101 4.313-1.456 9.342-.495 13.927a24.777 24.777 0 0 1 4.334-.489c1.243-.028 1.771-.072 2.662-.016 3.806-.016 7.773-.335 9.459 3.776 1.186 2.887-.086 6.6-2.58 8.349-1.372.964-3.052.83-4.641.803-2.476-.042-5.266.237-7.65-.598-2.418-.847-4.369-2.618-5.861-4.775a21.317 21.317 0 0 0-3.431 5.922c-3.769 9.891-.162 22.18 6.552 29.922-.293-.338-3.229-.037-3.675-.048-.495-.011-3.323.283-3.672-.121-8.41-9.693-11.628-26.277-2.562-36.6 1.294-1.472 2.815-2.656 4.459-3.623a22.228 22.228 0 0 1-1.069-4.038c-1.09-6.645.672-13.675 3.266-19.761C-8.902-38.446-4.755-44.199.844-47.919c5.263-3.499 11.226-2.974 17.25-2.733",
    style: {
      fill: "#00d08f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 20.01 68.264)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-1.928-1.104-2.165-3.682-1.527-5.553 1.34-3.943 5.694-6.917 9.729-9.138 2.598-1.528 6.121-3.027 6.121-3.027 4.229-1.712 8.379-2.206 13.051-2.185.614.102 1.141.218 1.583.337l-.026-.006-.12-.026c-1.349.127-2.703.349-3.992.76-2.557.811-5.003 2.063-7.359 3.326-.533.285-1.103.593-1.692.923-3.547 1.894-7.249 5.162-7.249 5.162-1.591 1.618-2.772 3.468-3.06 5.556a3.75 3.75 0 0 0 .083 1.363C5.777-1.387 6.96-.257 7.844.453c-1.336.186-4.66.318-6.173.058C1.062.427.488.28 0 0",
    style: {
      fill: "#00b77a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 26.456 77.466)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-.039-.006z",
    style: {
      fill: "#ff5a9d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 27.808 85.065)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c2.616-6.138 6.763-11.891 12.362-15.611 3.053-2.028 6.341-2.702 9.739-2.864 1.698.114 3.131.302 3.929.419-1.309.234-2.566.697-3.783 1.224-2.995 1.3-5.547 3.502-7.768 5.853C9.712-5.933 6.61.7 4.904 7.37c-1.101 4.314-1.456 9.342-.495 13.927.164.868.171 1.028.744 2.7 1.169 3.361 3.202 6.308 6.365 8.311 1.062.819 2.617 1.223 3.936 1.423-.604.024-1.213-.002-1.81-.011-2.477-.042-5.267.238-7.651-.598-2.418-.847-4.369-2.618-5.861-4.775-1.285-1.992-2.329-4.548-2.329-4.548a22.228 22.228 0 0 1-1.069-4.038C-4.356 13.116-2.594 6.086 0 0",
    style: {
      fill: "#00b77a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 17.588 80.12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s-3.828-10.453-16.824-13.458c-.004 2.887-1.664 5.685-1.664 5.685S-4.379-3.61-5.604 5.344C-3.375 4.775 0 0 0 0",
    style: {
      fill: "#fb639e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 73.001 16.841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s-5.065 7.672-8.427 8.572c.715-5.772-2.277-10.322-6.12-13.707l5.806-7.548C-2.275-6.55 0 0 0 0",
    style: {
      fill: "#f7d665",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 66.384 39.028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s4.789 7.847 4.175 11.272c-4.92-3.102-10.311-2.329-15.009-.291l-4.362-8.464C-6.896-.726 0 0 0 0",
    style: {
      fill: "#f7d665",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 9.344 51.388)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-5.759-5.073-13.433-7.527-13.433-7.527s2.486-4.498 2.471-9.151c7.408 1.861 12.855 5.419 16.767 9.131z",
    style: {
      fill: "#10b9bc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 32.278 55.02)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 8.134 9.339L11.749 0z",
    style: {
      fill: "#fb639e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 51.228 57.09)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 1.808 12.653 6.928-6.327z",
    style: {
      fill: "#fbd45d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 59.125 16.645)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s-6.137-22.254-32.485-30.672c-.498 5.967-4.403 11.467-4.403 11.467S-8.436-8.204-12.491 10.091C-7.788 9.293 0 0 0 0",
    style: {
      fill: "#fb639e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 134.86 67.517)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c5.073-5.76 7.526-13.434 7.526-13.434s4.498 2.486 9.153 2.47c-1.862 7.409-5.42 12.856-9.131 16.769z",
    style: {
      fill: "#fb639e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 75.111 42.543)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c5.073-5.76 7.526-13.434 7.526-13.434s4.498 2.486 9.153 2.47c-1.862 7.409-5.42 12.856-9.131 16.769z",
    style: {
      fill: "#fb639e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 52.794 66.663)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 16.284 19.073 1.057-26.181z",
    style: {
      fill: "#25dfe8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 95.771 63.776)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-12.653 1.808 6.326 6.928z",
    style: {
      fill: "#0fb8cb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 118.6 70.885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-12.653 1.808 6.326 6.928z",
    style: {
      fill: "#00d08f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 85.052 64.883)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-6.094-11.236-5.991 19.326z",
    style: {
      fill: "#fb639e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 122.916 119.744)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-6.094-11.235-5.991 19.326z",
    style: {
      fill: "#fb639e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 86.905 21.864)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s-4.33-12.286-19.496-15.987c-.045 3.378-2.025 6.628-2.025 6.628S-5.072-4.287-6.634 6.173C-4.018 5.54 0 0 0 0",
    style: {
      fill: "#00d08f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 101.283 95.78)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s-8.16 3.538-9.955 14.044c2.304-.13 4.612 1.062 4.612 1.062S-2.676 3.66 4.522 4.222C3.967 2.471 0 0 0 0",
    style: {
      fill: "#fb639e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 91.763 120.775)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s6.355 3.685 7.229 6.324C2.591 6.021-.899 8.619-3.422 11.842l-6.289-4.281C-5.119 2.118 0 0 0 0",
    style: {
      fill: "#f7d665",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 62.684 121.575)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s7.557-5.236 11.011-4.821c-2.81 5.091-1.727 10.428.58 15l-8.197 4.845C-.324 6.927 0 0 0 0",
    style: {
      fill: "#f7d665",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 70.2 66.327)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-3.78 4.83-5.381 11.064-5.381 11.064s-3.703-1.774-7.415-1.545c1.141-5.998 3.728-10.506 6.506-13.8z",
    style: {
      fill: "#10b9bc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 63.216 81.505)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-3.78 4.83-5.381 11.064-5.381 11.064s-3.704-1.774-7.415-1.545c1.141-5.998 3.728-10.506 6.506-13.8z",
    style: {
      fill: "#10b9bc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 103.086 15.373)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 18.731-16.676-26.197-.513z",
    style: {
      fill: "#00d08f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 84.991 79.29)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 7.073-6.922-7.618-2.45z",
    style: {
      fill: "#fb639e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 48.44 118.62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 10.009-2.028-5.367-5.234z",
    style: {
      fill: "#fbd45d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 98.46 107.283)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 12.527-2.539-6.717-6.55z",
    style: {
      fill: "#0fb8cb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 101.022 78.459)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 6.734 10.863L18.615-1.082z",
    style: {
      fill: "#0fb8cb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 60.771 54.317)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 5.382 8.68L9.265-7.015z",
    style: {
      fill: "#0fb8cb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 77.321 102.513)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 5.382 8.68L9.265-7.015z",
    style: {
      fill: "#0fb8cb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 117.58 57.378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s10.187 12.729 29.632 10.843c-1.34-4.01-.341-8.667-.341-8.667s-21.529.796-24-12.207C2.461-8.203 0 0 0 0",
    style: {
      fill: "#00d08f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 10.603 105.448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s-8.56 11.454-2.675 27.544c3.109-2.022 7.282-2.2 7.282-2.2S-.812 7.242 9.681 2.281C7.504.283 0 0 0 0",
    style: {
      fill: "#f7d665",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 121.339 110.743)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s-14.211-18.191-41.771-15.848c1.83 5.7.337 12.278.337 12.278s30.496-.766 33.774 17.683C-3.623 11.57 0 0 0 0",
    style: {
      fill: "#00d08f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.31763 .1535 .1535 -.31763 45.85 44.092)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s-9.029-1.732-11.151-4.489c5.605-1.556 8.657-6.066 10.308-10.915l9.197 2.463C5.174-4.616 0 0 0 0",
    style: {
      fill: "#f7d665",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 30.106 88.954)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-4.395 8.866 8-.197z",
    style: {
      fill: "#fb639e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 59.723 99.478)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-9.94-8.034 1.888 20.144z",
    style: {
      fill: "#0fb8cb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 31.958 103.877)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-7.343 5.246-7.258-5.362 2.72 8.604-7.342 5.246 9.023.072 2.721 8.604 2.856-8.56 9.024.072-7.258-5.362z",
    style: {
      fill: "#f7d665",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 25.193 46.495)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-2.152 5.852-6.231-.24 4.9 3.857-2.153 5.851 5.181-3.468 4.9 3.855-1.697-6L7.93 6.239 1.698 6z",
    style: {
      fill: "#fb639e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 131.829 99.128)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-2.152 5.852-6.231-.24 4.9 3.857-2.153 5.851 5.181-3.468 4.9 3.855-1.697-6L7.93 6.239 1.698 6z",
    style: {
      fill: "#00d08f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 73.585 34.99)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 3.904-4.732-9.678.808z",
    style: {
      fill: "#fb639e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 93.88 128.69)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-3.855-4.771L-5 4.871z",
    style: {
      fill: "#0fb8cb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 105.173 116.746)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-3.531 5.016 9.588-1.543z",
    style: {
      fill: "#fb639e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 68.662 130.145)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-4.475-.355L.258 4.588z",
    style: {
      fill: "#f7d665",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 130.247 106.669)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 3.904-4.731-9.677.807z",
    style: {
      fill: "#fb639e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 33.594 116.91)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 7.247-9.208-13.021 5.284z",
    style: {
      fill: "#fb639e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 94.559 87.376)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 4.435.697-4.342-5.29z",
    style: {
      fill: "#f7d665",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 48.46 122.81)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-1.758 4.042 9.595 4.173 1.758-4.042z",
    style: {
      fill: "#f7d665",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 50.437 108.991)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-3.532 5.017 9.59-1.543z",
    style: {
      fill: "#fb639e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 128.383 88.574)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-3.531 5.016 9.588-1.543z",
    style: {
      fill: "#00d08f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 50.654 91.705)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 1.446-4.164-9.885-3.43-1.446 4.165z",
    style: {
      fill: "#f7d665",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 119.702 93.28)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 3.52-4.267-8.726.729z",
    style: {
      fill: "#fb639e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 26.268 33.474)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 3.521-4.267-8.727.728z",
    style: {
      fill: "#fb639e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 12.746 29.176)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 3.999.629L.084-4.142z",
    style: {
      fill: "#f7d665",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 40.893 52.087)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 3.52-4.267-8.726.729z",
    style: {
      fill: "#fb639e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 32.622 67.918)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 3.521-4.267-8.728.728z",
    style: {
      fill: "#fb639e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 83.493 56.774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 3.999.629L.084-4.142z",
    style: {
      fill: "#f7d665",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 42.652 81.385)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-1.585 3.644 8.652 3.763 1.585-3.644z",
    style: {
      fill: "#f7d665",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 43.167 67.361)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-3.477-4.303-1.032 8.696z",
    style: {
      fill: "#0fb8cb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 86.476 40.713)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-3.186 4.523 8.648-1.392z",
    style: {
      fill: "#fb639e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 102.088 45.921)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-3.186 4.523 8.647-1.392z",
    style: {
      fill: "#fb639e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 132.063 61.312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-3.184 4.523 8.645-1.392z",
    style: {
      fill: "#fb639e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 63.146 57.747)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-4.035-.322L.232 4.136z",
    style: {
      fill: "#f7d665",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 101.917 34.025)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 3.653 4.152.668-8.73z",
    style: {
      fill: "#0fb8cb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 66.495 106.88)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 2.993-4.652-8.58 1.752z",
    style: {
      fill: "#fb639e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 17.402 85.917)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 4.045.154-4.45-4.275z",
    style: {
      fill: "#f7d665",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 43.626 108.076)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-1.145 3.805 9.036 2.716 1.144-3.805z",
    style: {
      fill: "#f7d665",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 41.89 96.696)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 3.972.107.262-9.429-3.973-.11z",
    style: {
      fill: "#00d08f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 6.153 78.723)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-3.959-3.863v8.757z",
    style: {
      fill: "#0fb8cb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 94.976 77.31)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-2.631 4.867 8.424-2.402z",
    style: {
      fill: "#fb639e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 118.83 85.916)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-2.629 4.867 8.421-2.401z",
    style: {
      fill: "#fb639e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 72.883 83.925)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 .852-3.882-9.217-2.02-.85 3.881z",
    style: {
      fill: "#f7d665",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 108.376 84.424)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-3.971.193.459 9.424 3.969-.193z",
    style: {
      fill: "#00d08f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 138.693 79.628)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 4.556-3.138-8.593-1.692z",
    style: {
      fill: "#0fb8cb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 61.2 66.652)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-4.267-3.52.73 8.726z",
    style: {
      fill: "#fb639e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 60.503 47.065)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-4.267-3.521.729 8.727z",
    style: {
      fill: "#fb639e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 74.477 23.467)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-4.266-3.521.728 8.728z",
    style: {
      fill: "#fb639e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 71.2 93.604)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 .577-3.932-9.335-1.371-.576 3.932z",
    style: {
      fill: "#00d08f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 50.89 15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-4.304 3.477 8.697 1.032z",
    style: {
      fill: "#0fb8cb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 88.17 98.98)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 4.523 3.186-1.391-8.648z",
    style: {
      fill: "#fb639e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 82.436 123.682)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 4.523 3.184-1.391-8.645z",
    style: {
      fill: "#fb639e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 75.203 72.109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-.322 4.035L4.136-.232z",
    style: {
      fill: "#f7d665",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 93.492 111.673)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-3.755-1.304-3.092 8.914 3.755 1.303z",
    style: {
      fill: "#f7d665",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 82.685 113.125)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 3.228 4.493 1.521-8.625z",
    style: {
      fill: "#0fb8cb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 60.68 32.32)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 3.434-4.335-8.71.902z",
    style: {
      fill: "#fb639e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 37.344 24.65)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 3.435-4.335-8.711.901z",
    style: {
      fill: "#fb639e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 84.076 12.443)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 3.942.499 1.186-9.36-3.943-.498z",
    style: {
      fill: "#00d08f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 10.947 36.974)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-3.093 4.586 8.616-1.564z",
    style: {
      fill: "#fb639e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 67.067 14.856)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-3.424-6.316-1.138 12.625z",
    style: {
      fill: "#0fb8cb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 81.056 33.93)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-3.239 6.52 8.661-1.874z",
    style: {
      fill: "#fb639e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 94.194 35.95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-3.239 6.519 8.662-1.872z",
    style: {
      fill: "#fb639e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 50.784 47.875)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 1.348-5.435-8.876-4.651-1.348 5.436z",
    style: {
      fill: "#f7d665",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 99.928 24.068)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 2.888-6.862-8.54 2.828z",
    style: {
      fill: "#fb639e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 19.206 52.01)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 2.887-6.861-8.539 2.827z",
    style: {
      fill: "#fb639e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 71.356 49.646)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 3.975.031.049-13.719-3.973-.03z",
    style: {
      fill: "#00d08f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.34928 -.04954 -.04954 -.34928 0 61.4)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfetti);
export default __webpack_public_path__ + "static/media/confetti.1c60c9c966e950423a9a05dd29933c9b.svg";
export { ForwardRef as ReactComponent };